import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { City, PenaltyRegistry } from 'src/app/classes';
import { EntityTypeEnum, ITranslation } from 'src/app/classes/ITranslation';
import { SettingsmanagerService } from 'src/app/services/settingsmanager.service';
import { WidgetsmanagerService } from 'src/app/services/widgetsmanager.service';
import { WsmanagerService } from 'src/app/services/wsmanager.service';
@Component({
  selector: 'app-penalty',
  templateUrl: './penalty.component.html',
  styleUrls: ['./penalty.component.scss']
})
export class PenaltyComponent implements OnInit {
  @Input()
  public penalty: PenaltyRegistry;

  @Input()
  public cities: City[];

  @Output('closeEvent')
  public closeEvent: EventEmitter<void> = new EventEmitter<void>();

  public measureUnit = [
    { value: 'gg', label: 'days' },
    { value: 'min', label: 'minutes' },
    { value: 'fx', label: 'fixed amount' },
    { value: 'fa', label: 'amount not estabilied' }
  ];

  public validation_messages: any;
  public form: FormGroup;

  // supporto modale tranduzioni
  public showTranslationsModal = false;
  public translations: ITranslation[] = [];
  public subscriptions: Subscription[] = [];
  public entityType: EntityTypeEnum = EntityTypeEnum.Penalty;
  public entityId = -1;
  public isSpinnerLoading = false;

  constructor(
    private formBuilder: FormBuilder,
    private wsManager: WsmanagerService,
    private translate: TranslateService,
    private widgetsManager: WidgetsmanagerService,
    private settingsManager: SettingsmanagerService
  ) {}

  ngOnInit() {
    this.form = this.formBuilder.group({
      id: [this.penalty ? this.penalty.id : null, []],
      cityId: [this.penalty ? this.penalty.cityId : null, [Validators.required]],
      name: [this.penalty ? this.penalty.name : '', [Validators.required]],
      code: [this.penalty ? this.penalty.code : '', [Validators.required]],
      amount: [this.penalty ? this.penalty.amount : 0, [Validators.required, Validators.min(0)]],
      description: [this.penalty ? this.penalty.description : '', []],
      isDeductible: [this.penalty ? this.penalty.isDeductible : false, [Validators.required]],
      measureUnit: [this.penalty ? this.penalty.measureUnit : '', [Validators.nullValidator]],
      vatCode: [this.penalty ? this.penalty.vatCode : '', [Validators.required, Validators.maxLength(200)]]
    });

    this.validation_messages = {
      code: [{ type: 'required', message: 'Field is required.' }],
      name: [{ type: 'required', message: 'Field is required.' }],
      cityId: [{ type: 'required', message: 'Field is required.' }],
      amount: [{ type: 'required', message: 'Field is required.' }],
      isDeductible: [{ type: 'required', message: 'Field is required.' }],
      measureUnit: [{ type: 'nullValidator', message: 'Field is required.' }],
      vatCode: [{ type: 'required', message: 'Field is required.' }]
    };

    if (this.penalty && this.penalty.id) {
      this.entityId = +this.penalty.id;
    }
    this.loadTranslationsByEntity();
  }

  loadTranslationsByEntity() {
    if (!this.entityId || this.entityId <= 0) {
      this.isSpinnerLoading = false;
      this.translations = [];
      return;
    }

    this.isSpinnerLoading = true;
    this.subscriptions.push(
      this.wsManager.fetchTranslations(this.entityType, this.entityId).subscribe(
        (response) => {
          console.log('@@@@@ translations by entity');
          this.translations = response;
        },
        (err) => {
          console.error('Error fetching translations:', err);
          this.isSpinnerLoading = false;
        },
        () => {
          this.isSpinnerLoading = false;
          console.log('Completed fetching translations.');
        }
      )
    );
  }

  close(): void {
    if (this.closeEvent) {
      this.closeEvent.emit();
    }
  }

  onSubmit(values: PenaltyRegistry): void {
    const obs = this.penalty && this.penalty.id ? this.wsManager.editPenalty(values) : this.wsManager.newPenalty(values);
    obs.subscribe(
      (data) => {
        this.penalty = data;
        this.widgetsManager.showToastMessage('success', 'Penalty saved successfully');
        this.close();
      },
      (err) => {
        this.widgetsManager.showToastMessage('danger', 'Error saving penalty');
      }
    );
  }

  delete(): void {
    this.wsManager.deletePenalty(this.penalty.id).subscribe(
      () => {
        this.widgetsManager.showToastMessage('success', this.translate.instant('Penalty deleted successfully'));
        this.closeEvent.emit();
      },
      (err) => {
        this.widgetsManager.showToastMessage('danger', this.translate.instant('Error while removing penalty'));
      }
    );
  }

  refreshContent(refreshEvent: { method: 'CREATE' | 'DELETE' | 'EDIT'; translation: ITranslation }) {
    const lang = this.settingsManager.getLanguageSetting();
    const { method, translation } = refreshEvent;
    switch (method) {
      case 'CREATE':
        this.translations.push(translation);
        this.translations = [...this.translations];
        break;
      case 'DELETE':
        this.translations = this.translations.filter((t) => t.id !== translation.id);
        break;
      case 'EDIT': {
        const index = this.translations.findIndex((t) => t.id === translation.id);
        this.translations[index] = translation;
        break;
      }
    }
    if (translation.locale === lang) {
      if (translation.value === '') {
        this.form.get(translation.field).setValue(this.penalty[translation.field]);
      } else {
        this.form.get(translation.field).setValue(translation.value);
      }
    }
  }

  changeEntityLanguage(language: string) {
    this.settingsManager.setLanguageSetting(language);
    const fieldsToReset = ['name', 'description'];
    fieldsToReset.forEach((field) => {
      if (this.form.get(field)) {
        this.form.get(field).setValue(this.penalty[field]);
      }
    });
    const localizedtranslations = this.translations.filter((t) => t.locale === language);
    localizedtranslations.forEach((lt) => {
      this.form.get(lt.field).setValue(lt.value);
    });
  }
}
